import script from "./AnswerResultPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AnswerResultPage.vue?vue&type=script&lang=ts&setup=true"

import "./AnswerResultPage.vue?vue&type=style&index=0&id=238b3c4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238b3c4c"]])

export default __exports__